"use client";

import AutoScroll from "embla-carousel-auto-scroll";
import { useReducedMotion } from "motion/react";
import { CircleFlag } from "react-circle-flags";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { TRANSLATION_LANGUAGES } from "@/lib/translation-languages";

interface LanguageFlagMarqueeProps {
  className?: string;
}

const LanguageFlagMarquee = ({ className }: LanguageFlagMarqueeProps) => {
  const reduceMotion = useReducedMotion() ?? false;

  return (
    <div className={cn("relative w-full overflow-hidden", className)}>
      <p className="sr-only">
        {`Available languages: ${TRANSLATION_LANGUAGES.map(
          (language) => language.language,
        ).join(", ")}.`}
      </p>

      <Carousel
        aria-hidden
        opts={{ loop: !reduceMotion, dragFree: true, align: "start" }}
        plugins={
          reduceMotion
            ? []
            : [
                AutoScroll({
                  playOnInit: true,
                  speed: 1,
                  stopOnInteraction: false,
                  stopOnMouseEnter: true,
                }),
              ]
        }
      >
        <CarouselContent className="items-center">
          {TRANSLATION_LANGUAGES.map((language) => (
            <CarouselItem
              key={language.code}
              className="flex basis-1/4 justify-center sm:basis-1/5 md:basis-1/6 lg:basis-1/8"
            >
              <CircleFlag
                countryCode={language.countryCode}
                alt=""
                height={48}
                width={48}
                className="size-10 shrink-0 rounded-full md:size-12"
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>

      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-linear-to-r from-background to-transparent md:w-24" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-linear-to-l from-background to-transparent md:w-24" />
    </div>
  );
};

export { LanguageFlagMarquee };
